/*global versaTagObj*/
/*global fbq*/
/*global snaptr*/
/*global gtag*/
/*global criteo_q*/
/*global uetq*/
/*eslint no-undef: ["error", { "typeof": true }] */

import Vue from 'vue'

Vue.prototype.$cookieconsent = window.CookieConsent

Vue.prototype.$university = (index) => {
    switch (index) {
        case 'PEGASO':
            return {
                name: 'Università Telematica Pegaso',
                logo: '',
                api: 'pegaso',
                direzionale_id: 5,
                ecp: 'ecp'
            } 
        case 'MERCATORUM': 
            return  {
                name: 'Universitas Mercatorum',
                logo: '',
                api: 'mercatorum',
                direzionale_id: 4,
                ecp: 'ei-point'
            }
    }
}

Vue.prototype.$crm_oc_category = (course) => {
    switch (course.cat_id) {
        case 1:
            if (course.id_level == 1) {
                return 3
            } else {
                return 4
            }
        case 3:
        case 4:
            return 5
        case 2:
        case 6:
        case 8: 
        case 9:
            return 7
        default:
            return 15
    }
}

Vue.prototype.$gclid = () => {
    var p1 = 'gclid';
    var match1 = RegExp('[?&]' + p1 + '=([^&]*)').exec(window.location.search);
    var gclidParam = match1 && decodeURIComponent(match1[1].replace(/\+/g, ' '));
    var gclidRecord = null;

    var p2 = 'gclsrc';
    var match2 = RegExp('[?&]' + p2 + '=([^&]*)').exec(window.location.search);
    var gclsrcParam = match2 && decodeURIComponent(match2[1].replace(/\+/g, ' '));
    var isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;

    if (gclidParam && isGclsrcValid) {
        var expiryPeriod = 90 * 24 * 60 * 60 * 1000; 
        var expiryDate = new Date().getTime() + expiryPeriod;
        gclidRecord = { value: gclidParam, expiryDate: expiryDate };
        localStorage.setItem('gclid', JSON.stringify(gclidRecord));
    }

    var gclid = gclidRecord || JSON.parse(localStorage.getItem('gclid'));
    var isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;

    if (isGclidValid) {
        return gclid.value;
    } else {
        return null;
    }
}

Vue.prototype.$ga_id = function() {
    var name = "_ga" + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    var cookie = "";
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            cookie = c.substring(name.length, c.length);
        }
    }
    
    if (cookie !== "") {
        return cookie.substring(6);
    } else {
        return null;
    }
}

Vue.prototype.$hubspotutk = () => {
    var name = "hubspotutk" + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    var cookie = "";
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            cookie = c.substring(name.length, c.length);
        }
    }
    
    if (cookie !== "") {
        return cookie;
    } else {
        return null;
    }
}

Vue.prototype.$cookie = (cookie_name, cookie_default = null) => {
    var name = cookie_name + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    var cookie = '';
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            cookie = c.substring(name.length, c.length);
        }
    }
    if (cookie !== "") {
        if (cookie_name == '_ga') {
            return cookie.substring(6);
        } else {
            return cookie;
        }
    } else {
        return cookie_default;
    }
}

Vue.prototype.$trackGoogleAnalyticsBeginCheckout = (category, amount) => {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'begin_checkout', {
            'event_category': 'ecommerce',
            'event_label': category,
            'value': amount
        })
    }
}

Vue.prototype.$trackGoogleAdsConversion = (send_to, category, amount, course) => {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'conversion', {
            'send_to': send_to,
            'value': amount,
            'currency': 'EUR',
            'category': category,
            'course': course
        });
    }
}

Vue.prototype.$trackFloodlightConversion = (send_to, crm_id, category, course, amount, gender, birth_date, ecp, entrance, ga_id, cid) => {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'purchase', {
            'allow_custom_scripts': true,
            'value': amount,
            'transaction_id': crm_id,
            'quantity': '1',
            'u1': 'alta',
            'u2': course,
            'u3': category,
            'u4': gender,
            'u5': birth_date,
            'u6': ecp,
            'u7': entrance,
            'u8': ga_id,
            'send_to': send_to,
            'dc_custom_params': {
                'match_id': cid,
            }
        });
    }
}

Vue.prototype.$trackSnapChatAddCart = (category, code) => {
    if (typeof snaptr !== 'undefined') {
        snaptr('track', 'ADD_CART', {
            'item_category': category,
            'item_ids': [code]
        })
    }
}

Vue.prototype.$trackSnapChatPurchase = (category, code, amount) => {
    if (typeof snaptr !== 'undefined') {
        snaptr('track', 'PURCHASE', {
            'item_category': category,
            'item_ids': [code],
            'price': amount,
            'currency': 'EUR'
        })
    }
}

Vue.prototype.$trackFacebookAddToCart = (code) => {
    if (typeof fbq !== 'undefined') {
        fbq('track', 'AddToCart', {
            content_ids: code,
            content_type: 'product'
        }); 
    }
}

Vue.prototype.$trackFacebookCompleteRegistration = (event_id) => {
    if (typeof fbq !== 'undefined' && event_id !== 0) {
        fbq('track', 'CompleteRegistration', {}, { eventID: event_id }) 
    }
}

Vue.prototype.$trackFacebookPurchase = (code, value) => {
    if (typeof fbq !== 'undefined') {
        fbq('track', 'Purchase', {
            content_ids: code,
            content_type: 'product',
            currency: 'EUR', 
            value: value
        });
    }
}

Vue.prototype.$trackCriteoAddCart = (account, code, amount) => {
    if (typeof criteo_q !== 'undefined') {
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        criteo_q.push(
            { event: "setAccount", account: account},
            { event: "setSiteType", type: deviceType},
            { event: "addToCart", item: [{ 
                id: code, 
                price: amount, 
                quantity: 1 
            }]}
        );
    }
}

Vue.prototype.$trackCriteoSale = (account, id, code, amount) => {
    if (typeof criteo_q !== 'undefined') {
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        criteo_q.push(
            { event: "setAccount", account: account},
            { event: "setSiteType", type: deviceType},
            { event: "trackTransaction", id: id, item: [{
                id: code, 
                price: amount, 
                quantity: 1
            }]}
        );
    }
}

Vue.prototype.$trackBingSignUp = (category, amount) => {
    if (typeof uetq !== 'undefined') {
        uetq.push('event', 'signup', {
            "event_category": category,
            "revenue_value": amount,
            "currency": "EUR"
        });
    }
}